
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Search, MessageCircle, CreditCard, ThumbsUp } from "lucide-react";
import { Link } from "react-router-dom";

const steps = [
  {
    icon: Search,
    title: "Browse & Search",
    description: "Explore our diverse range of services or search for specific skills you need."
  },
  {
    icon: MessageCircle,
    title: "Connect & Discuss",
    description: "Message providers to discuss your project requirements and get quotes."
  },
  {
    icon: CreditCard,
    title: "Hire & Pay",
    description: "Choose your provider and make secure payments through our platform."
  },
  {
    icon: ThumbsUp,
    title: "Review & Repeat",
    description: "Leave feedback and hire the same provider again for future projects."
  }
];

const benefits = [
  "Access to skilled providers across all categories",
  "Secure payment processing",
  "24/7 customer support",
  "Quality guarantee on all services",
  "Easy project management tools",
  "Transparent pricing and reviews"
];

const HowToHire = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-12">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h1 className="font-poppins font-bold text-4xl md:text-5xl mb-4">How to Hire Providers</h1>
          <p className="font-inter text-xl text-gray-600 max-w-3xl mx-auto">
            Find the perfect provider for your project and get quality work delivered on time.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-16">
          {steps.map((step, index) => (
            <Card key={index} className="h-full">
              <CardHeader>
                <div className="flex items-center space-x-4">
                  <div className="bg-purple-100 p-3 rounded-full">
                    <step.icon className="h-6 w-6 text-purple-600" />
                  </div>
                  <div>
                    <CardTitle className="font-poppins">{step.title}</CardTitle>
                  </div>
                </div>
              </CardHeader>
              <CardContent>
                <CardDescription className="font-inter text-gray-600">
                  {step.description}
                </CardDescription>
              </CardContent>
            </Card>
          ))}
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 mb-16">
          <Card>
            <CardHeader>
              <CardTitle className="font-poppins text-2xl">Why Choose Our Platform</CardTitle>
              <CardDescription className="font-inter">
                We make hiring easy, safe, and efficient.
              </CardDescription>
            </CardHeader>
            <CardContent>
              <ul className="space-y-3">
                {benefits.map((benefit, index) => (
                  <li key={index} className="flex items-center space-x-3">
                    <ThumbsUp className="h-5 w-5 text-green-500 flex-shrink-0" />
                    <span className="font-inter text-gray-700">{benefit}</span>
                  </li>
                ))}
              </ul>
            </CardContent>
          </Card>

          <Card>
            <CardHeader>
              <CardTitle className="font-poppins text-2xl">Ready to Find a Provider?</CardTitle>
              <CardDescription className="font-inter">
                Start your search and connect with talented providers today.
              </CardDescription>
            </CardHeader>
            <CardContent className="space-y-4">
              <Button asChild className="w-full" size="lg">
                <Link to="/discover-services">Browse Services</Link>
              </Button>
              <Button asChild variant="outline" className="w-full" size="lg">
                <Link to="/safety-guidelines">Safety Guidelines</Link>
              </Button>
            </CardContent>
          </Card>
        </div>
      </div>
    </div>
  );
};

export default HowToHire;
